import styled, { css } from "styled-components";
import buildColor from "@tvg/atomic-ui/_static/ColorPalette";
import { fontMedium } from "@tvg/atomic-ui/_static/Typography";

const hiddenMixin = css<{ isHidden?: boolean }>`
  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
    `}
`;

export const Container = styled.div`
  position: relative;
`;

export const FieldGroup = styled.div<{ isHidden?: boolean }>`
  display: flex;
  flex-direction: column;
  ${hiddenMixin}
`;

export const Label = styled.label`
  margin-bottom: 4px;
  line-height: 22px;
  font-family: ${fontMedium};
  font-weight: 500;
  font-size: 14px;
  color: ${buildColor("grey", "900")};
`;

export const FieldContainer = styled.div<{
  isFocused?: boolean;
  hasError?: boolean;
}>`
  height: 44px;
  padding: 8px 12px;
  background-color: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("blue", "100")};
  box-shadow: 0 1px 2px ${buildColor("blue", "000")};
  border-radius: 4px;

  ${({ isFocused }) =>
    isFocused &&
    css`
      border: 2px solid ${buildColor("blue_accent", "500")};
      padding: 7px 11px;
    `}

  ${({ hasError }) =>
    hasError &&
    css`
      border: 2px solid ${buildColor("orange", "600")};
      padding: 7px 11px;
    `}
`;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${buildColor("white", "100")};
  z-index: 1;
  border-radius: 4px;
`;
